import enLocale from "element-ui/lib/locale/lang/en";
export const en = {
  /* A字打头时公共的 */
  A001: "Home",
  A002: "Booking",
  A003: "Flights",
  A004: "Intl Flights",
  A005: "Hotels",
  A006: "Trains",
  A007: "Application",
  A008: "Approval",
  A009: "Order",
  A010: "Search",
  A011: "Add",
  A012: "Reset",
  A013: "Log",
  A014: "Time",
  A015: "Operator",
  A016: "Content",
  A017: "Remark",
  A018: "No Log",
  A019: "Traveler",
  A020: "Details",
  A021: "Enter keywords to filter",
  A022: "Name/Employee No./Mobile/Email",
  A023: "Department",
  A024: "Select Department",
  A025: "Employee No.",
  A026: "Type",
  A027: "Name",
  A028: "Gender",
  A029: "Type",
  A030: "Department",
  A031: "Mobile",
  A032: "Email",
  A033: "Selected",
  A034: "people",
  A035: "Cancel",
  A036: "Confirm",
  A037: "Upload",
  A038: "Upload up to 5 attachments",
  A039: "Attachment info",
  A040: "Select traveler",
  A041: "Approval info",
  A042: "Approval node",
  A043: "Approver",
  A044: "Type",
  A045: "Status",
  A046: "Remark",
  A047: "Edit",
  A048: "Delete",
  A049: "Save",
  A050: "Application",
  A051: "Submit",
  A052: "Return",
  A053: "Waiting",
  A054: "All",
  A055: "Costcenter",
  A056: "Time",
  A057: "From",
  A058: "To",
  A059: "Depart",
  A060: "Type",
  A061: "City or airport",
  A062: "City or airport",
  A063: "Select Date",
  A064: "",
  A065: "Return",
  A066: "Select Date",
  A067: "screening",
  A068: "Business",
  A069: "Advanced search",
  A070: "Search",
  A071: "Select travelers",
  // 'A072': 'Not open no TR to booking',
  A072: "Please select the travel list",
  A073: "Select travelers",
  A074: "Travel grade is empty, cannot be search",
  A075:
    "Travelers policy is inconsistent, please choose the appropriate traveler：",
  A076: "The traveler is inconsistent, please search again",
  A077: "Out of policy",
  A078: "Non booking",
  A079: "Empty",
  A080: "Unlimited",
  A081: "Sort by time",
  A082: "Sort by price",
  A083: "Violate",
  A084: "Ticket Policy",
  A085: "Return",
  A086: "Change",
  A087: "Book",
  A088: "Travel level",
  A089: "Next",
  A090: "Select Reasoncode",
  A091: "Travel policy",
  A092: "Out of policy",
  A093: "Select Reasoncode",
  A094: "Other",
  A095: "Please input reason",
  A096: "Price",
  A097: "Ticket policy",
  A098: "Out of policy",
  A099: "Name",
  A100: "Type",
  A101: "Certificate ID",
  A102: "Please maintain the ID of travelers",
  A103: "Department",
  A104: "Name",
  A105: "Mobile",
  A106: "Booked by",
  A107: "Confirm order",
  A108: "Service fee",
  A109: "Amount",
  A110: "Details",
  A111: "Ticket",
  A112: "Change",
  A113: "Return",
  A114: "status",
  A115: "Status",
  A116: "Select order status",
  A117: "Select approval status",
  A118: "View details",
  A119: "Booking time",
  A120: "Order info",
  A121: "Ticket No.",
  A122: "Refund",
  A123: "Change",
  A124: "Number",
  A125: "Amount",
  A126: "Adult",
  A127: "Hotel",
  A128:
    "For refund, please fill in the relevant infor as far as possible, The travel consultant will ask by phone If the description is not clear enough, you will be asked by the back office service staff by phone. Please keep the phone open.",
  A129:
    "For change, please fill in the relevant infor as far as possible, The travel consultant will ask by phone If the description is not clear enough, you will be asked by the back office service staff by phone. Please keep the phone open.",
  A130: "Please select at least 1 traveler",
  A131: "Please select at least 1 traveler",
  A132: "Please fill in the reason for return",
  A133: "Please fill in the reason for change",
  A134: "Explanation of return service fee",
  A135: "Operator",
  A136: "Department",
  A137: "Name",
  A138: "Mobile",
  A139: "Refund of ticket fee",
  A140: "Refund fee",
  A141: "Refund amount",
  A142: "Application",
  A143: "View",
  A144: "Approval",
  A145: "Order",
  A146: "Ticket details",
  A147: "ID",
  A148: "Return",
  A149: "Change fee",
  A150: "Change time",
  A151: "Old No.",
  A152: "Costcenter",
  A153: "Refund info",
  A154:
    "1. Refund fee will not be charged if the ticket is refunded more than 15 days before driving; 2. 5% of the ticket price will be charged if the ticket is returned more than 48 hours before the driving time; 3. 10% of the ticket price will be charged if the driving time is more than 24 hours but less than 48 hours; 4. 20% of the ticket price will be charged if the driving time is less than 24 hours. 5. Within 48 hours to 15 days before departure, if the ticket is cancelled 15 days before the departure, if the ticket is changed or changed to other trains which are more than 15 days away from the station, 5% of the refund fee will still be charged. Note: the above online refund is only applicable to the tickets that have not taken out paper tickets and no later than 30 minutes before departure * * Guangzhou Shenzhen Hong Kong high speed railway refund service charge note: * * - within 48 hours before the ticket driving time, 50% of the face price is calculated, and the refund fee is calculated by yuan, and the part less than one yuan will be exempted- From 48 hours to 14 days before the ticket driving time, 30% of the face value of the ticket price is calculated, and the refund fee is calculated according to yuan, and the part less than one yuan is free of charge. If the ticket is 15 days or more before the ticket driving time, it is calculated as 5% of the face price, and the refund fee is calculated according to yuan, and the part less than 1 CNY is free of charge.",
  A155: "Booked by",
  A156: "Train ticket refund",
  A157: "Refund details",
  A158:
    "1. Refund fee will not be charged if the ticket is refunded more than 15 days before driving; 2. 5% of the ticket price will be charged if the ticket is returned more than 48 hours before the driving time; 3. 10% of the ticket price will be charged if the driving time is more than 24 hours but less than 48 hours; 4. 20% of the ticket price will be charged if the driving time is less than 24 hours. 5. Within 48 hours to 15 days before departure, if the ticket is cancelled 15 days before the departure, if the ticket is changed or changed to other trains which are more than 15 days away from the station, 5% of the refund fee will still be charged. Note: the above online refund is only applicable to the tickets that have not taken out paper tickets and no later than 30 minutes before departure * * Guangzhou Shenzhen Hong Kong high speed railway refund service charge note: * * - within 48 hours before the ticket driving time, 50% of the face price is calculated, and the refund fee is calculated by yuan, and the part less than one yuan will be exempted- From 48 hours to 14 days before the ticket driving time, 30% of the face value of the ticket price is calculated, and the refund fee is calculated according to yuan, and the part less than one yuan is free of charge. If the ticket is 15 days or more before the ticket driving time, it is calculated as 5% of the face price, and the refund fee is calculated according to yuan, and the part less than 1 CNY is free of charge.",
  A159: "Return time",
  A160: "Refund No.",
  A161: "Return info",
  A162: "View return",
  A163: "Refund amount",
  A164: "Return reason",
  A165: "Return policy",
  A166: "Refund of ticket fee",
  A167: "Operator",
  A168: "Department",
  A169: "Name",
  A170: "Mobile",
  A171: "View change",
  A172: "Change amount",
  A173: "Hot cities",
  A174: "Select reasoncode",
  A175: "Please re select travel level",
  A176: "+",
  A177: "Travel policy",
  A178: "Regardless",
  A179: "address",
  A180:
    "Note: the location of map signs is for reference only, and the actual road sign information shall prevail",
  A181: "Nothing",
  A182: "Order searching……",
  A183: "Order details searching……",
  A184: "Approving……",
  A185: "Rejecting……",
  A186: "Referral……",
  A187: "Approvel seaching……",
  A188: "Appreved details Seaching……",
  A189: "No city data",
  A190: "Unfind",
  A191: "Out of policy",
  A192: "",
  A193: "Please select type",
  A194: "Expiration date",
  A196: "Select month",
  A197: "Confirm close?",
  A198: "Air searching……",
  A199: "Custormer Support",
  A200: "Sign out",
  A201: "Normal Sign in",
  A202: "User name / Mobile",
  A203: "Please enter",
  A204: "Company ID",
  A205: "Password",
  A206: "Security code",
  A207: "Sign in",
  A208: "Sign in successfully",
  A209: "Signing in……",
  A210: "Comfirm Sign out？",
  A211: "Chinese",
  A212: "Remark",
  A213: "Mobile Sign in",
  A214: "Please enter Security code",
  A215: "please enter your phone number",
  A216: "Send Security code",
  A217: "Wechat Sign in",
  A218: "Please enter User name",
  A219: "Please enter Password",
  A220: "Airport",
  A221: "Hot Cities",
  A222: "Booking successful",
  A223: "Booking failure",
  A224: "Loading……",
  A225: "Advance",
  A226: "Notice",
  A227: "Itinerary",
  A228: "Used trips",
  A229: "Trips loading",
  A230: "No trip info",
  A231: "BeiJing",
  A232: "ShangHai",
  A233: "ShangHai Airlines",
  A234: "China Eastern Airlines",
  A235: "Attention: Mobile booking at any time",
  A236: "official account: Yuci Travel Management",
  A237: "No Data",
  A238: "Please use wechat scan QR code to login",
  A239: "“ ZongQu Travel”",
  A240: "Company management",
  A241: "official account: Eland travel management",
  A242: "“Eland Travel”",
  A243: "official account：1Travel Management",
  A244: "“1Travel”",
  A245: "Please input reason",
  A246: "Fare difference",
  A247: "Tax difference",
  /* B字打头是出差申请  其中会包含一些业务模块的单词 */
  B001: "Application",
  B002: "Reason/No./Traveler/Costcenter/Department",
  B003: "Trip date",
  B004: "Select date",
  B005: "Select date",
  B006: "No application",
  B007: "Trip Reason",
  B008: "Trip date",
  B009: "Department",
  B010: "Applicant",
  B011: "Time",
  B012: "Departure date",
  B013: "Return date",
  B014: "Costcenter",
  B015: "Budget",
  B016: "Select Costcenter",
  B017: "Traveler",
  B018: "Please enter trip reason",
  B019: "Trip details",
  B020: "Traffic",
  B021: "Hotel",
  B022: "Catering",
  B023: "Subsidy",
  B024: "Others",
  B025: "Account",
  B026: "From",
  B027: "City",
  B028: "To",
  B029: "City",
  B030: "Checkin",
  B031: "Start date",
  B032: "Date",
  B033: "",
  B034: "Checkout",
  B035: "End date",
  B036: "Return date",
  B037: "Days",
  B038: "Budget",
  B039: "Total subsidy",
  B040: "Travel expenses - Flights",
  B041: "Travel expenses - Intl Flights",
  B042: "Travel expenses - Trains",
  B043: "Travel expenses - Hotel",
  B044: "Travel expenses - Catering",
  B045: "Travel expenses - Subsidy",
  B046: "Travel expenses - Others",
  B047: "One way",
  B048: "Return",
  B049: "Catagory",
  B050: "Daily allowance",
  B051: "View application",
  B052: "Modify application",
  B053: "Add application",
  B054: "Please setup approval infor before operation!",
  B055: "Please input the necessary infor!",
  B056: "Please select traveler!",
  B057: "Please maintain the trip details",
  B058: "Application details",
  B059: "Confirm delete application??",
  B060: "Application",
  B061: "Select application",
  B062: "Application No.",
  B063: "Please enter application No.",
  B064: "Submitting application……",
  B065: "Associated order",
  B066: "Trip info",

  /* C 打头的是机票 国内 国际都包括 */
  C001: "No results",
  C002: "Airlines",
  C003: "Class",
  C004: "Air Type",
  C005: "Departure Airport",
  C006: "Arrival Airport",
  C007: "Remove stops",
  C008: "Remove share",
  C009: "Remove Violate",
  C010: "Class",
  C011: "Fights No.",
  C012: "Share",
  C013: "",
  C014: "Stops",
  C015: "Hide",
  C016: "Show More",
  C017: ">9",
  C018: "% off",
  C019: "Full",
  C020: "Selected flights",
  C021: "Stops",
  C022: "Stops time",
  C023: "Discount",
  C024: "Tax",
  C025: "Price check failed. Please select other flight",
  C026: "All day lowest price",
  C027: "From",
  C028: "To",
  C029: "Around",
  C030: "-hour lowest price",
  C031: "Fright info",
  C032: "No tax",
  C033: "Price",
  C034: "Tax",
  C035: "Fuel",
  C036: "Refresh search",
  C037: "Booking Fright",
  C038: "Confirm submit Booking？",
  C039: "出发/Departure/Arrival Airport",
  C040: "Depart time",
  C041: "First time",
  C042: "Latest time",
  C043: "",
  C044: "No result",
  C045: "Departure Airport",
  C046: "Arrival Airport",
  C047: "Fright Order",
  C048: "Fright details",
  C049: "All day lowest price",
  C050: "Departure time",
  C051: "-hour lowest price",
  C052: "Price",
  C053: "Trip type",
  C054: "Fright info",
  C055: "Refund tax",
  C056: "Refund fuel",
  C057:
    "Note: Refund Fee is for reference only, subject to the fee confirmed by the travel consultant！",
  C058: "Refund fright",
  C059: "Confirm submit Refund？",
  C060: "Refund",
  C061: "Refund ticket price",
  C062: "Change Fright info",
  C063: "Change Fright info",
  C064: "Fright info",
  C065:
    "Note: Change Fee is for reference only, subject to the fee confirmed by the travel consultant！",
  C066: "Fright Change",
  C067: "Confirm submit Change？",
  C068: "Fright Change",
  C069: "Intl Frights Order",
  C070: "Select depart",
  C071: "Select return",
  C072: "Show more",
  C073: "Hide",
  C074: "Children price",
  C075: "Baby price",
  C076: "Notes for ticket policy",
  C077: "Stops time",
  C078: "Transit",
  C079: "Duration",
  C080: "",
  C081: "Depart",
  C082: "Return",
  C083: "Luggage allowance",
  C084: "Local time",
  C085: "Select",
  C086: "Book",
  C087: "Seaching ticket policy，please try again later……",
  C088: "Seaching Luggage allowance，please try again later……",
  C089: "Checking class/price……",
  C090: "Select Airlines",
  C091: "Select Class",
  C092: "Submitting Intl Fright order……",
  C093: "Submitting Fright order……",
  C094: "Submitting refund order……",
  C095: "Submitting change order……",
  C096: "Intl Fright details",
  C097: "Intl Fright book",
  C098: "Name",
  C099: "Email",
  C100: "Area code",
  C101: "Itinerary",
  C102: "OK",
  C103: "Current price",
  C104: "Select costcenter",
  C105: "Duration more than",
  C106: "hours",
  C107: "kilometre",
  C108: "Confirm submit Frights？",
  C109: "Expected class",
  C110: "CostCenter",
  C111: "Information",
  C112: "Cancel",
  C113: "Application",
  C114: "Cancelled Successfully",
  C115: "Cancelled Failed",
  C116: "Add Application",
  C117: "Select CostCenter",
  C118: "Select Applicant",
  C119: "Please enter remark",
  C120: "Edit Itinerary",
  C121: "Departure",
  C122: "Add Itinerary",
  C123: "Add Segment",
  C124:
    "For complicated international flights, please submit an application for travel plan. The professional travel consultant will customize the international travel plan for you",
  C125: "Add Application",
  C126: "Travel Plan",
  C127: "Supplier",
  C128: "Quotation duration",
  C129: "Confirmation plan ",
  C130: "Yes ",
  C131: "No ",
  C132:
    "This operation will cancel this plan application. Do you want to continue?",
  C133: "Plan Application ",
  C134:
    "Travel Consultant has received your request and is trying to customize your travel plan. Please wait patiently……",
  C135: "Please enter the total budget ",
  C136: "Reject ",
  C137: "Please enter flight No ",
  C138: "Modify application successful ",
  C139: "Submit application successfully ",
  C140: "Save application successfully ",
  C141: "International travel plan ",
  C142: "Are you sure you want to delete the plan ",
  C143: "Please enter flight time ",
  C144: "Are you sure you want to reject the programme ",
  /* D 打头的是火车票 */
  D001: "Trains",
  D002: "No results",
  D003: "Train number",
  D004: "From",
  D005: "To",
  D006: "Price",
  D007: "Select Seats",
  D008: "Hide",
  D009: "Show Stops",
  D010: "Change train info",
  D011: "Remain",
  D012: "plenty",
  D013: "",
  D014: "Minute",
  D015: "Filter",
  D016: "Empty",
  D017: "Type",
  D019: "Intercity high-speed trains",
  D018: "Selected Number",
  D020: "Non-stop trains",
  D021: "Express train",
  D022: "High-speed trains",
  D023: "Other trains",
  D025: "Departure time",
  D026: "",
  D027: "Departure",
  D028: "Arrival",
  D029: "Class",
  D030:
    "Tip: Due to the different seats, the ticket prices are different, subject to the actual price.",
  D031: "",
  D032: "Contacts",
  D033: "Tip",
  D034: "Do you accept no seat??",
  D035: "Reject",
  D036: "Accept",
  D037: "Please enter your Name",
  D038: "Please enter phone number",
  D039: "Ticket info",
  D040: "Select Seats",
  D041:
    "The system will apply for your seat at random if the system ticket is insufficient",
  D042: "Window",
  D043: "Aisle",
  D044: "Original train number",
  D045: "Booking trains",
  D046: "Confirm submit Booking？",
  D047: "Departure Station",
  D048: "Arrival Station",
  D049: "No result",
  D050: "Departure/Arrival Station",
  D051: "Departure Date",
  D052: "Arrival Date",
  D053: "The train number cannot be changed",
  D054: "Confirm submit Change？",
  D055: "Change Trains number info",
  D056: "Ticket details",
  D057: "Seach Ticket",
  D058: "Change Ticket",
  D059: "Change details",
  D060: "Return Ticket",
  D061: "Confirm submai Return?",
  D062: "Trains",
  D063: "Submitting Return……...",
  D064: "Submitting Change……",
  D065: "Submitting Order……",

  /* E打头的是酒店 */
  E001: "Cities",
  E002: "Select City",
  E003: "Select checkin time",
  E004: "Select checkout time",
  E005: "Keyword",
  E006: "Select Keyword",
  E007: "Confirm City！",
  E008: "Select City！",
  E009: "Select checkin time",
  E010: "Select checkout time",
  E011: "location",
  E012: "Price",
  E013: "≤",
  E014: "",
  E015: "≥",
  E016: "The maximum amount cannot be less than the minimum amount！",
  E017: "Rating",
  E018: "Brand",
  E019: "Facilities",
  E020: "No results",
  E021: "Please enter the full amount range",
  E022: "Rating",
  E023: "First tier cities",
  E024: "Standards for second tier cities",
  E025: "Standards for second tier cities",
  E026: "Browsing history",
  E027: "Hotel Info",
  E028: "Location",
  E029: "Hotel List",
  E030: "Hotel Info",
  E031: "Hotel Tel",
  E032: "Hotel Service",
  E033: "Hotel Introduction",
  E034: "No pictures",
  E035: "Breakfast",
  E036: "",
  E037: "Special price room",
  E038: "Non-refundable",
  E039: "Pay Cancellation",
  E040: "Before",
  E041: "Day",
  E042: "on the arrival date",
  E043: "Before 24h on the arrival date",
  E044: "h",
  E045: "Pay at Hotel",
  E046: "Selected room",
  E047: "No breakfast",
  E048: "Checkin time",
  E049: "Total",
  E050: "",
  E051: "Number",
  E052: "Latest checkin time",
  E053: "",
  E054: "Tip: Usually check-in at 14:00, early arrival may need to wait",
  E055: "Hotel order",
  E056: "Confirm No.",
  E057: "Refund No.",
  E058: "Traveler",
  E059: "Booking time",
  E060: "Hotel details",
  E061: "Type",
  E062: "",
  E063: "Non",
  E064: "-",
  E065: "Standard Price",
  E066: "Pay info",
  E067: "Cancelled policy",
  E068: "Refund",
  E069: "Standard Price",
  E070: "Stay days",
  E071: "Days",
  E072: "Total =（Standard Price + Service Fee）* Stay days * rooms",
  E073: "Rooms",
  E074: "Booking Hotel",
  E075: "Confirm submit Booking？",
  E076: "Refund",
  E077: "Confirm submit Refund？",
  E078: "Refund time",
  E079: "Refund policy",
  E080: "Refund Reason",
  E081: "Standard Price",
  E082: "Please input Refund reason",
  E083: "Refund of Hotel Price",
  E084: "Order details",
  E085: "Refund order details",
  E086: "Checkin/Checkout",
  E087: "Hotel",
  E088: "No results",
  E089: "Submitting Hotel order……",
  E090: "Submitting Hotel refund……",
  E091: "Confirm Hotel refund？",
  E092: "Latest Cancelled time",
  E093: "Free Cancelled time",
  E094: "Pay of Cancelled",
  E095: "Guarantee:",
  E096: "Card number",
  E097: "Cardholder",
  E098: "Select Expiration date",
  E099: "The credit card is not available!",
  E100: "Please input CVV",
  E101: "Please input info",
  E102: "Select Cardholder",
  E103: "First-tier cities",
  E104: "Second-tier cities",
  E105: "The third-class cities",
  E106: "Location",
  E107: "Airport/Station",
  E108: "Metro Station",
  E109: "Brand",
  E110: "Breakfast",

  /* F打头的是我的审批 */
  F001: "Trip",
  F002: "Application",
  F003: "Application details",
  F004: "Please input remark",
  F005: "Approval",
  F006: "Reject",
  F007: "Referral",
  F008: "Approval operation",
  F009: "Select approver",
  F010: "Confirm approval？",
  F011: "Confirm reject？",
  F012: "Confirm referral？",
  F013: "Frights",
  F014: "Intl Frights",
  F015: "Hotel",

  /* G大头的是个人中心 */
  G001: "Profile",
  G002: "Certificate info",
  G003: "Secretary",
  G004: "Security",
  G005: "Family",
  G006: "Customers",
  G007: "Birthday",
  G008: "Login account",
  G009: "Travel level",
  G010: "Role",
  G011: "Edit",
  G012: "User name",
  G013: "Select Birthday",
  G014: "Save",
  G015: "Successful",
  G016: "Failure",
  G017: "Saving……",
  G018: "Add Certificate",
  G019: "Country",
  G020: "Operation",
  G021: "It cannot be restored after deletion",
  G022: "Add Certificate info",
  G023: "Last Name",
  G024: "Name",
  G025: "Last Name（Pinyin）",
  G026: "Name（Pinyin）",
  G027: "Select Birthday",
  G028: "Select Country",
  G029: "Edit Certificate info",
  G030: "Saving……",
  G031: "Contact Tel",
  G032: "Add Travel Secretary",
  G033: "Change Password",
  G034: "Old Password",
  G035: "New Password",
  G036: "Confirm",
  G037: "Please input old password",
  G038: "Please input new password",
  G039: "Please input password again",
  G040: "The two inputs are inconsistent！",
  G041: "Add family",
  G042: "Chinese Name",
  G043: "Birthday",
  G044: "Country",
  G045: "Add family info",
  G046: "Edit family info",
  G047: "Modifying……",
  G048: "Saving……",
  G049: "Saving……",
  G050: "Add external customers",
  G051: "Edit external customers",
  G052: "Add customers",
  G053: "Approval setup",
  G054: "My Agent approval",
  G055: "Select agent approval",
  G056: "Empty agent approval",
  G057: "Effective date range",
  G058: "Confirm empty agent approval",
  G059: "Date range",

  "00000": "Request error, operation failed!",
  // Refund ticket new fields
  R200: "Refund Type",
  R201: "Refund Reason",
  R202: "Situation Description",
  R203: "Voluntary Refund",
  R204: "Involuntary Refund",
  R205: "Flight changes/cancellations",
  R206: "Unable to fly for health reasons",
  R207: "Unable to fly for special reasons",
  R208: "Other circumstances",
  R209: "Please select refund reason",
  R210: "Please fill in the situation description",
  // Refund ticket detail page display
  R211: "Refund Type",
  R212: "Refund Reason",
  R213: "Situation Description",

  ...enLocale
};

export default en;



// WEBPACK FOOTER //
// ./src/i18n/langs/en.js